// eslint-disable-next-line import/prefer-default-export
export enum BillingStatus {
  TRIALING = 'trialing',
  TRIAL_EXPIRED = 'trial_expired',
  PAYING = 'paying',
  CANCELED = 'canceled',
}
